import ProductDetailImages from '~/themes/base/components/product/ProductDetailImages'

export default {
  extends: ProductDetailImages,
}
